import React, {useEffect, useState} from 'react'
import {MapContainer, Marker, Popup, TileLayer, useMapEvents} from "react-leaflet";

import {LeafletMapTileUrl} from "@/constants/config";
import RenderIf from "@/components/render-if";

import {blueIcon, redIcon} from "@/components/map/_section/icons";
import UserLocationControl from "@/components/map/_section/UserLocationController";
import FlyToPoint from "@/components/map/_section/flyTo";


export default function IranMap(
    {
        points,
        lockPoint,
        onChange,
        clickHandler = true,
        myLocationDetector = false,
        setItemClicked,
        popupElement,

    }) {

    const defaultZoom = 18

    const [clickedPoint, setClickedPoint] = useState({latitude: 0, longitude: 0, zoom: defaultZoom});
    const [first, setFirst] = useState(true)


    useEffect(() => {


        if (first && lockPoint?.latitude && lockPoint?.longitude) {
            setClickedPoint({...lockPoint, zoom: defaultZoom});
            setFirst(false)
        }

    }, [lockPoint]);

    function MapClickHandler() {
        useMapEvents({
            click(e) {
                onChange?.({
                    latitude: e.latlng.lat,
                    longitude: e.latlng.lng
                });
                setClickedPoint({latitude: e.latlng.lat, longitude: e.latlng.lng, zoom: defaultZoom});
            }

        });

        return null;
    }


    return (
        <MapContainer
            center={[
                lockPoint?.latitude || clickedPoint?.latitude || 36.287756638657,
                lockPoint?.longitude || clickedPoint?.longitude || 59.615045017376
            ]}
            zoom={13}
            style={{
                height: '100%',
                borderRadius: 16
            }}
        >


            <TileLayer url={LeafletMapTileUrl()}/>


            {/*<FlyToPoint point={clickedPoint} />*/}


            <RenderIf condition={clickHandler}>
                <MapClickHandler/>
            </RenderIf>

            <RenderIf condition={clickedPoint?.latitude && clickedPoint?.longitude}>
                <Marker position={[clickedPoint?.latitude, clickedPoint?.longitude]}
                        icon={clickedPoint?.icon ?? redIcon}>
                    {popupElement && (
                        <Popup>
                            {React.cloneElement(popupElement, {item: clickedPoint})}
                        </Popup>
                    )}
                </Marker>
                <FlyToPoint point={clickedPoint} zoom={clickedPoint?.zoom ?? defaultZoom}/>
            </RenderIf>

            <RenderIf condition={points?.length > 0}>
                {points?.map((item, index) => (
                    <RenderIf
                        key={item?.latitude + '-' + item?.longitude + '-' + index}
                        condition={item?.latitude && item?.longitude}>
                        <Marker
                            position={[item?.latitude, item?.longitude]}
                            icon={blueIcon}
                            eventHandlers={{
                                click: () => {
                                    setItemClicked?.(item);
                                    setClickedPoint(
                                        {
                                            lat: item.latitude,
                                            lng: item.longitude,
                                            zoom: 14,
                                            icon: blueIcon,
                                        });
                                }
                            }}
                        >
                            {popupElement && (
                                <Popup>
                                    {React.cloneElement(popupElement, {item: item})}
                                </Popup>
                            )}


                        </Marker>
                    </RenderIf>

                ))}
            </RenderIf>

            <RenderIf condition={myLocationDetector}>
                <UserLocationControl/>
            </RenderIf>

        </MapContainer>
    );
}



